import {Loader, MantineProvider, Modal} from '@mantine/core';
import {DEFAULT_NICKNAME} from '../../../../../core/entities/community/constants';
import {convertNlToBr} from '../../../../../shared/services/convertNlToBr';

export const ConfirmCommentFormModal: React.FC<{
  nickname: string;
  body: string;
  opened: boolean;
  close: () => void;
  postCommentFunc: () => void;
  isPostLoading: boolean;
}> = ({nickname, body, opened, close, postCommentFunc, isPostLoading}) => {
  return (
    <MantineProvider>
      <Modal
        opened={opened}
        onClose={close}
        withCloseButton={false}
        size={668}
        padding={0}
        radius={12}
        centered={true}
      >
        <div className="p-16 border-b-[1px] border-line border-collapse">
          <p className="text-md text-black-1 font-bold leading">
            以下の内容で投稿します。よろしいですか？
          </p>
        </div>
        <div className="p-24">
          <div className="bg-background-1 p-16 rounded-4">
            <p className="text-base text-black-1 font-bold leading">投稿者</p>
            <p className="text-base text-black-1 leading mt-12">
              {nickname === '' ? DEFAULT_NICKNAME : nickname}
            </p>
          </div>
          <div className="bg-background-1 p-16 rounded-4 mt-16">
            <p className="text-base text-black-1 font-bold leading">投稿内容</p>
            <p className="text-base text-black-1 leading mt-12">
              {convertNlToBr(body)}
            </p>
          </div>
          {isPostLoading ? (
            <div className="h-64 flex justify-center items-center">
              <Loader color="gray" />
            </div>
          ) : (
            <div className="mt-32 flex justify-center items-center">
              <button
                className="w-[128px] bg-black-4 py-12 px-24 text-base text-white leading font-bold rounded-full hover:opacity-80 mr-24"
                onClick={close}
              >
                キャンセル
              </button>
              <button
                className="w-[128px] bg-primary-1 py-12 px-24 text-base text-white leading font-bold rounded-full hover:opacity-80"
                onClick={postCommentFunc}
              >
                投稿する
              </button>
            </div>
          )}
        </div>
      </Modal>
    </MantineProvider>
  );
};
